import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    Box,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    Card,
    CardHeader,
    Avatar,
    Divider,
    CardContent,
    Grid
} from '@mui/material';
import { Link } from 'react-router-dom';

// import required css from library
import "react-datepicker/dist/react-datepicker.css";
import PropTypes from 'prop-types';
import '../../OKRs/OKRs.css';
import { Close } from '@mui/icons-material';
import { CustomizedSnackbar } from '../../../../shared/index';
import moment from "moment";
import { TimeConversion } from "../../../../utils/TimeConversion";



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    // ValidatorForm.addValidationRule("")
    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};


const ViewComments = (props) => {


    const open = props && props.open;
    const id = props && props.okrId;


    useEffect(() => {

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (

        <React.Fragment>

            <BootstrapDialog
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth="sm"
                maxWidth="sm"
                onClose={() => props.toggleCommentsPopup(2)}
            >


                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={() => props.toggleCommentsPopup(2)}
                    className="modal-heading"
                >
                    Review Comments
                </BootstrapDialogTitle>

                <DialogContent dividers>
                    <Box
                        component="form"
                        autoComplete="off"
                    >
                    <Grid container spacing={2}>
                        {
                            props && props.commentList !== undefined && props.commentList.length !== 0 && props.commentList.map((comments) => {
                                return (
                                    <Grid item xs={12}>
                                        <Card sx={{ position: "relative", padding: "10px", marginBottom: "10px" }}>
                                            <CardHeader avatar={<Avatar aria-label="recipe">
                                                <Link to={`/users-profile/${comments.createdBy}`}> {comments.createdByName !== null ? comments.createdByName.charAt(0) : ""}</Link>
                                            </Avatar>}

                                                title={comments.createdByName !== null ? <Link className="comment-created" to={`/users-profile/${comments.createdBy}`}>{comments.createdByName}</Link> : ""}
                                                subheader={comments.createdDate !== null ? "created at " + TimeConversion(comments.createdDate, 0) : ""}
                                            />
                                            <Divider />
                                            <CardContent sx={{ marginTop: "10px" }}>{comments.comment !== null ? comments.comment : null}</CardContent>
                                        </Card>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                    </Box>
                </DialogContent>
                {/* <DialogActions> */}
                    {/* <Button></Button> */}
                    {/* <Button className="theme-btn cancel-btn" onClick={props.onClose}>Close</Button> */}
                {/* </DialogActions> */}

            </BootstrapDialog>
            <CustomizedSnackbar />
        </React.Fragment >

    );
};




export default ViewComments;
